import { render, staticRenderFns } from "./QuestionTab.vue?vue&type=template&id=4b60e80a"
import script from "./QuestionTab.vue?vue&type=script&lang=js"
export * from "./QuestionTab.vue?vue&type=script&lang=js"
import style0 from "./QuestionTab.vue?vue&type=style&index=0&id=4b60e80a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports